/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useEffect } from 'react'
import useProgressiveCount from '../../hooks/useProgressiveCount/useProgressiveCount'
import { getMergedClassNames } from '../../utils/HTMLutils'
import './Doughnut.scss'
const rootClassName = 'component-doughnut'

interface DoughnutProps {
  value: number | string
  showLabel?: boolean
  red?: boolean
}

function Doughnut(props: DoughnutProps) {
  const [val, setVal] = useProgressiveCount(0)

  const getStrokeDashOffset = (value: string | number) => {
    return 264 - (264 * parseInt(String(value))) / 100
  }

  useEffect(() => {
    setVal(parseInt(String(props.value)))
  }, [props.value])

  return (
    <div className={rootClassName}>
      <div
        className={getMergedClassNames([
          `${rootClassName}-chart`,
          props.red ? 'red' : ''
        ])}
      >
        <svg viewBox='0 0 100 100'>
          <circle cx='50' cy='50' r='42' />
          <circle
            cx='50'
            cy='50'
            r='42'
            strokeDashoffset={getStrokeDashOffset(val!)}
          />
        </svg>
      </div>
      {props.showLabel ? (
        <div className={`${rootClassName}-label nunito`}>{`${val}%`}</div>
      ) : undefined}
    </div>
  )
}

Doughnut.defaultProps = {
  showLabel: true
}

export default memo(Doughnut)
